// Claude: New component — alpha-tester feedback: "add a password reset function for logged in
// Claude: users." Modelled on PasswordResetForm.js (same layout/classes), but for a user who is
// Claude: already authenticated: posts to /v1/auth/change_password/ (custom_auth/views.py) with the
// Claude: current password plus the desired new one, using getValidAccessToken like every other
// Claude: authenticated request in this app (see TermAdmin.js/AddWord.js).
import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";
import Logo from "../logo512.png";
import { useTranslation } from "react-i18next";
import "../i18n";
import { baseUrl, getValidAccessToken } from "../shared";
import Navbar from "../navbar";
import Navbaranonuser from "../navbaranonuser";

function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const { auth } = useContext(AuthContext);
  const { t } = useTranslation();

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Passwords don't match");
      return;
    }
    const token = await getValidAccessToken();
    const response = await fetch(baseUrl + "v1/auth/change_password/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ current_password: currentPassword, new_password: password }),
    });
    const data = await response.json();
    setMessage(data.message || data.error);
    if (response.ok) {
      setCurrentPassword("");
      setPassword("");
      setConfirmPassword("");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {localStorage.setItem("bladsy", "ChangePassword")}
      {auth.userName === null && <Navbaranonuser />}
      {auth.userName != null && <Navbar />}

      <div className="flex flex-col justify-center items-center p-2">
        <h1 className="text-4xl font-bold mb-6">
          <Link to={"/"}>{t("change_password")}</Link>
        </h1>
        <div className="w-full max-w-3xl bg-white rounded-lg shadow-lg p-3">
          <form onSubmit={handleSubmit}>
            <label htmlFor="change-password-current">{t("current_password")}:</label>
            <input
              id="change-password-current"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              onKeyDown={handleKeyDown}
              placeholder={t("password")}
              className="border border-2 p-2 mb-4 w-full max-w-3xl rounded-lg"
            />
            <label htmlFor="change-password-new">{t("new_password")}:</label>
            <input
              id="change-password-new"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              onKeyDown={handleKeyDown}
              placeholder={t("password")}
              className="border border-2 p-2 mb-4 w-full max-w-3xl rounded-lg"
            />
            <label htmlFor="change-password-confirm">{t("confirm_new_password")}:</label>
            <input
              id="change-password-confirm"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              onKeyDown={handleKeyDown}
              placeholder={t("password")}
              className="border border-2 p-2 mb-4 w-full max-w-3xl rounded-lg"
            />
            <button
              type="submit"
              className="w-full bg-cyan-700 text-white py-2 mt-4 px-4 rounded-lg hover:bg-cyan-800"
            >
              {t("change_password")}
            </button>
            <p>{message}</p>
          </form>
        </div>
      </div>
      <div className="flex flex-col mt-4 justify-center items-center p-4">
        <Link to={"/"}>
          <img src={Logo} alt="Logo" width="100" height="100" />
        </Link>
      </div>
    </div>
  );
}

export default ChangePassword;
